// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {loadCompaniesRequest, loadCompaniesSuccess, } from './actionCreators';
import fetch from 'cross-fetch'
import ApiService from '../services/api';
import { showSnackbar } from "../actions/snackbarActions";


export function loadCompanies() {
  return (dispatch, getState) => {
    let state = getState();
    return dispatch(getCompanies(state))
  }
}

function getCompanies(state) {
  let token = state.oidc.user.access_token;

  return dispatch => {
    dispatch(loadCompaniesRequest())
    return fetch(process.env.API_URL + '/api/Companies', {
      headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then(response => response.json())
      .then(json => dispatch(loadCompaniesSuccess(json)))
  }
}

export const createNew = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const newCompany = await apiService.createNew("companies", content);
      dispatch({
        type: 'COMPANIES_NEW_COMPANY',
        data: newCompany
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const editCompany = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const editedCompany = await apiService.edit("companies", content)
      dispatch({
        type: 'COMPANIES_EDIT_COMPANY',
        data: editedCompany
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const deleteCompany = (content) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: "DELETE_COMPANY_REQUEST",
        data: true
      });
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const deletedCompanyId = await apiService.delete("companies", content);
      await dispatch({
        type: "COMPANIES_DELETE_COMPANY",
        data: deletedCompanyId
      });
      dispatch({
        type: "DELETE_COMPANY_REQUEST",
        data: false
      });
      dispatch(showSnackbar("Company deleted"))
    }
    catch (err) {
      const message = err.message ? err.message : "Error: Company delete failed.";
      dispatch({
        type: "DELETE_COMPANY_REQUEST",
        data: false
      });
      dispatch(showSnackbar(message))
    }
  }
}


// Termporary solution for loading list
// of companies for Modals. Currently,
// there aren't any existing implementations
// that allow assign the companies to a variable.
export const loadCompaniesAsync = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;
    try {
      let apiService = new ApiService(token);
      const companies = await apiService.getAll("companies");
      return companies;
    }
    catch (ex) {
      console.error(ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/companyActions.js